/**
 * Copyright © Veeam Software Group GmbH.
 */

import { useContext } from 'react';

import { ConsumedPointsContext } from '../contexts/ConsumedPointsContext';

export const useConsumedPointsStore = () => useContext(ConsumedPointsContext);
